let language = {
    "A116P005": '感谢您的留言，我们稍后会通过电话或电子邮件与您联系。'
};

export { language }
